module.exports = __webpack_public_path__ + "img/perfilDefault.044ed1a2.png";